import { actions, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { createPayment } from 'services/api/payments/banktransfer'
import uuidv4 from 'uuid/v4'

import { TransactionType } from '../Transactions/types'
import { SubmitDepositAction, submitDepositError, submitDepositSuccess } from './actions'
import { SUBMIT_DEPOSIT } from './actionTypes'

const submitDepositSaga = function* (action: SubmitDepositAction) {
  const {
    payload: { amount, currency, paymentMethod }
  } = action
  const minorUnits = yield select((state) => selectors.currencies.getMinorUnits(state, currency))
  const amountInMinorUnits = String(Number(amount) * minorUnits)
  const orderId = uuidv4()
  const config = yield select(selectors.config.getConfig)
  const data = yield call(
    createPayment,
    orderId,
    amountInMinorUnits,
    currency,
    paymentMethod.id,
    config.openBankingCallback
  )
  if (!data.ok) {
    yield put(submitDepositError(data))
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(submitDepositSuccess(data.response))
  yield put(actions.payments.transactions.fetch(TransactionType.DEPOSIT))
}

export default function* methodsSagas() {
  yield takeEvery(SUBMIT_DEPOSIT, submitDepositSaga)
}
